import { render, staticRenderFns } from "./clientChannel.vue?vue&type=template&id=5f9a6726&"
import script from "./clientChannel.vue?vue&type=script&lang=js&"
export * from "./clientChannel.vue?vue&type=script&lang=js&"
import style0 from "./clientChannel.vue?vue&type=style&index=0&id=5f9a6726&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports